module.exports = __webpack_public_path__ + "static/media/ichilovlogo.a860e6d6.png";